export default {"src":"/_next/static/media/responsive-communication.fce07d82.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};